<!--
@Time : 2020/12/29 2:53 下午
@Author : yekong
@File : topx.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="topx">
      <div class="center">
        <div class="bt">亦源智能停车管理统计平台</div>
        <div class="time">{{ time }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "topx",
  data: function () {
    return {
      time: moment().format("HH:mm:ss")
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      type: Number,
      default() {
        return 0;
      }
    },
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
    var that = this;
    setInterval(function () {
      that.time = moment().format("HH:mm:ss");
    }, 1000);
  },
}
</script>

<style lang="scss" scoped>
.bt {
  color: #77f0ff;
  font-size: 0.30rem;
  text-align: center;
  font-weight: bold;
  text-shadow: 0px 5px 20px #09d7f1;
  letter-spacing: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
}

.topx {
  display: flex;
  background: url("../assets/topbg.png") center center no-repeat rgba(1, 4, 12, 1.00);
  background-size: 96% 100%;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  width: 100%;
  left: 0;
  height: 1rem;
  margin: auto;

  .center {
    width: 9.77rem;
    height: 1rem;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;

    .bt {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      height: 0.72rem;
    }

    .time {
      font-size: 0.22rem;
      font-weight: 400;
      color: #99FEFF;
      position: relative;
      height: 0.28rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      font-family: "ds-digitalnormal";
    }
  }

}
</style>
